import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import CompassLogo from "../Tools/CompassLogo";


const Navbar = () => {

  const [user, setUser] = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogOff = (e) => {

    localStorage.clear();

    setUser({});
  };

  useEffect(() => {

    if (user.email == undefined) {
      navigate("/");
    }

  }, [user])

  return (

    <nav className="navbar navbar-expand-lg navbar-light" style={{ borderBottom: "4px solid #e6e6e6" }}>
      <div className="container-fluid unselectable">

          <Link to="/" className="navbar-brand" style={{ fontWeight: "bold" }}><CompassLogo style={{height: "32px"}}/></Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor03" aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarColor03">

          {user["email"] != undefined && user["mustchangepassword"] != true &&
            <>
              <ul className="navbar-nav me-auto" style={{ fontWeight: "bold" }}>
                <li className="nav-item unselectable"><Link className="nav-link" to="/DesignFolder" style={{ paddingRight: "25px" }}>Design Project Library</Link></li>

                {/* <li className="nav-item"><Link className="nav-link" to="/Country" style={{paddingRight: "25px"}}>Countries</Link></li> */}
                <li className="nav-item unselectable"><Link className="nav-link" to="/Customer" style={{ paddingRight: "25px" }}>Customers</Link></li>
                <li className="nav-item unselectable"><Link className="nav-link" to="/Industry" style={{ paddingRight: "25px" }}>Industries</Link></li>
                <li className="nav-item unselectable"><Link className="nav-link" to="/MaterialHandled" style={{ paddingRight: "25px" }}>Materials Handled</Link></li>
                <li className="nav-item unselectable"><Link className="nav-link" to="/Sites" style={{ paddingRight: "25px" }}>Sites</Link></li>
                <li className="nav-item unselectable"><Link className="nav-link" to="/Eductor" style={{ paddingRight: "25px" }}>Eductors</Link></li>
                <li className="nav-item unselectable"><Link className="nav-link" to="/Choppers" style={{ paddingRight: "25px" }}>Choppers</Link></li>
                <li className="nav-item unselectable"><Link className="nav-link" to="/Cyclones" style={{ paddingRight: "25px" }}>Cyclones</Link></li>
                {/* <li className="nav-item unselectable"><Link className="nav-link" to="/Oilers" style={{ paddingRight: "25px" }}>Oilers</Link></li> */}

                <li className="nav-item dropdown unselectable" style={{ paddingRight: "25px" }}>
                  <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">Oilers</a>

                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/Oilers">Oilers</Link></li>
                    <li><Link className="dropdown-item" to="/Oils">Oils</Link></li>
                    <li><Link className="dropdown-item" to="/Oilers/TestDiagrams">Test Diagrams</Link></li>
                  </ul>
                </li>

                {/* <li className="nav-item"><Link className="nav-link" to="/State" style={{paddingRight: "25px"}}>States</Link></li> */}

                {user["role"] == "Admin" &&
                  <>
                    <li className="nav-item dropdown unselectable" style={{ paddingRight: "25px" }}>
                      <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">Admin</a>

                      <ul className="dropdown-menu">
                        {/* <li style={{marginLeft: "8px"}}>Manage</li>
                        <li><Link className="dropdown-item" to="/Country">Countries</Link></li>
                        <li><Link className="dropdown-item" to="/Customer">Customers</Link></li>
                        <li><Link className="dropdown-item" to="/Industry">Industries</Link></li>
                        <li><Link className="dropdown-item" to="/MaterialHandled">Materials Handled</Link></li>
                        <li><Link className="dropdown-item" to="/SiteLocation">Site Locations</Link></li>   
                        <li><Link className="dropdown-item" to="/State">States / Provinces</Link></li>    */}


                        {/* <div className="dropdown-divider"></div>     */}
                        {/* <li style={{marginLeft: "8px"}}>Admin</li> */}
                        <li><Link className="dropdown-item" to="/Account">Accounts</Link></li>
                        <li><Link className="dropdown-item" to="/Component">Components</Link></li>
                        <li><Link className="dropdown-item" to="/ComponentCategory">Component Categories</Link></li>

                        <li><Link className="dropdown-item" to="/EntryFactor">Entry Factors</Link></li>

                      </ul>
                    </li>
                  </>
                }
              </ul>
            </>
          }

          <ul className="nav navbar-nav navbar-right">

            {user["email"] != undefined &&
              <>
                <li className="nav-item dropdown" style={{ paddingLeft: "8px", display: "flex", flexDirection: "row" }}>
                  <div style={{ paddingTop: "15px" }} className="unselectable">Signed in as</div>
                  <a className="nav-link dropdown-toggle unselectable" style={{ color: "black" }} data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"> <b>{user["firstname"]}&nbsp;{user["lastname"]}</b></a>

                  <ul className="dropdown-menu" style={{ textAlign: "right" }}>
                    <li><Link className="dropdown-item" style={{ paddingRight: "8px" }} to="/ChangePassword">Change Password</Link></li>
                    <li><Link className="dropdown-item" style={{ paddingRight: "8px" }} to="https://dc.cssi.co/Admin/guide.pdf">User Guide</Link></li>
                    <div className="dropdown-divider"></div>
                    <li><button className="dropdown-item" onClick={handleLogOff}>Sign Out</button></li>
                  </ul>
                </li>
              </>
            }
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;